var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Navigation',{attrs:{"items":_vm.navigationItems,"logo-link":_vm.logoLink,"logo":_vm.logo}})
}
var staticRenderFns = []

export { render, staticRenderFns }